(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surplify-stock-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('surplify-stock-finder')) {
    customElements.define('surplify-stock-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        const form = this.querySelector('form');
        if (!form) return;
        this.bound = true;
        form.addEventListener('submit', event => {
          event.preventDefault();
          const term = form.elements.q.value.trim();
          const brand = form.elements.manufacturer.value.trim();
          if (!term && !brand) {
            window.location.assign(form.action.replace(/search\/?$/, 'collections/all'));
            return;
          }
          const destination = new URL(form.action);
          destination.searchParams.set('q', [term, brand ? 'vendor:' + JSON.stringify(brand) : ''].filter(Boolean).join(' '));
          destination.searchParams.set('type', 'product');
          destination.searchParams.set('options[unavailable_products]', 'last');
          window.location.assign(destination.toString());
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
